import React, { useContext } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { useStyles } from '../../custom-forms';
import AlternativeCalculationHeader from '../alternative-calculation/components/AlternativeCalculationHeader';
import OrderDetailsNew, { ExternalOrderDetailsNewProps } from './OrderDetailsNew';

export type ExternalOrderDetailsDialogProps = ExternalOrderDetailsNewProps & {
  onClose: () => void;
};

const OrderDetailsDialog: React.FC<ExternalOrderDetailsDialogProps> = ({ onClose, ...rest }) => {
  const context = useContext(ApplicationContext) as AppContext;
  const translatorService = context.translatorService;
  const c = useStyles();

  const title =
    translatorService.Tranlate('ORDERS_DIALOG_TITLE', 'Detalii comanda') +
    ' #' +
    rest.orderDetails.id;

  return (
    <Dialog open onClose={onClose} fullScreen fullWidth>
      <AlternativeCalculationHeader onClose={onClose} title={title} showReference={false} />
      <DialogContent className={c.pageBg} style={{ padding: 0 }}>
        <OrderDetailsNew {...rest} />
      </DialogContent>
    </Dialog>
  );
};

export default OrderDetailsDialog;
